import React from "react"
import './style.scss'
import { HomeIcon, ShowIcon, MovieIcon, PlansIcon, GenreIcon, ArticleIcon, CollectionIcon, CategoryIcon, MusicIcon, LiveIcon, LanguageIcon } from "./tabNavBarIcons"
import Cookies from 'js-cookie'
import userStore from '~/redux/user/store'
import connect from "~/tools/connect";
class TabNavBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: Cookies.get('tab_id') || "/",
            primaryColor: this.getPrimaryColor() || "#ffffff",
            primaryNavigation: this.getPrimaryNavigation() || []

        }
    }

    componentDidMount() {
        this.setState({id: window && window.location && window.location.pathname})
        this.addCssDynamically()
    }

    addCssDynamically = () => {
        return window && window.settings && window.settings.features && window.settings.features.enablePWA ? document.querySelector('style').textContent += "@media screen and (max-width:767px) { .modules { margin-bottom: 50px; }}" : ""
    }
    handleClick = (event) => {
        this.setState({ id: event.target.id })
        Cookies.set('tab_id', event.target.id)
    }

    getPrimaryColor = () => {
        return window && window.settings && window.settings.brand && window.settings.brand.cta && window.settings.brand.cta.primary && window.settings.brand.cta.primary.backgroundColor || "#ffffff"
    }

    getPrimaryNavigation = () => {
        return window && window.settings && window.settings.navigation && window.settings.navigation.primary || []
    }

    render() {
        const isSubscribed = this.state.user && this.state.user.isSubscribed
        const count = isSubscribed ? 5 : 4
        const color = this.state.primaryColor
        let primary = this.state.primaryNavigation
        primary = primary.filter((primary) => primary.url)
        const primaryComponent = primary ? primary.slice(0, count).map((primary) => {
            return (<div style={{ display: (isSubscribed && (primary.title).toLowerCase().includes("Plan".toLowerCase())) ? 'none' : 'block' }} className={`tabnavbar-item `}>
                <a className="anchor-tag" href={primary.url} id={primary.url} onClick={this.handleClick}>
                    {
                        (primary.icon && (primary.title).toLowerCase().includes("Home".toLowerCase()) && <HomeIcon color={color} id={this.state.id} url={primary.url} />) ||
                        (primary.icon && (primary.title).toLowerCase().includes("Show".toLowerCase()) && <ShowIcon color={color} id={this.state.id} url={primary.url} />) ||
                        (primary.icon && (primary.title).toLowerCase().includes("Movie".toLowerCase()) && <MovieIcon color={color} id={this.state.id} url={primary.url} />) ||
                        (primary.icon && (primary.title).toLowerCase().includes("Plan".toLowerCase()) && <PlansIcon color={color} id={this.state.id} url={primary.url} />) ||
                        (primary.icon && (primary.title).toLowerCase().includes("Genre".toLowerCase()) && <GenreIcon color={color} id={this.state.id} url={primary.url} />) ||
                        (primary.icon && (primary.title).toLowerCase().includes("Article".toLowerCase()) && <ArticleIcon color={color} id={this.state.id} url={primary.url} />) ||
                        (primary.icon && (primary.title).toLowerCase().includes("Collection".toLowerCase()) && <CollectionIcon color={color} id={this.state.id} url={primary.url} />) ||
                        (primary.icon && (primary.title).toLowerCase().includes("Categories".toLowerCase()) && <CategoryIcon color={color} id={this.state.id} url={primary.url} />) ||
                        (primary.icon && (primary.title).toLowerCase().includes("Song".toLowerCase()) && <MusicIcon color={color} id={this.state.id} url={primary.url} />) ||
                        (primary.icon && (primary.title).toLowerCase().includes("Live".toLowerCase()) && <LiveIcon color={color} id={this.state.id} url={primary.url} />) ||
                        (primary.icon && (primary.title).toLowerCase().includes("Language".toLowerCase()) && <LanguageIcon color={color} id={this.state.id} url={primary.url} />) ||
                        <div className="div-height"></div>
                    }
                    <div
                        className="tabnavbar-title"
                        style={{ color: this.state.id === primary.url ? color : "#ffffff" }}
                    >
                        {primary.title}
                    </div>
                </a>
            </div>)
        }) : <div></div>
        return (
            <div className="TabNavBar">
                <div className="tabnavbar-container">
                    {primaryComponent}
                </div>
            </div>
        )
    }
}

connect(TabNavBar, (state) => ({ user: state.user }), userStore)

export default TabNavBar;